// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ff1e843e","453":"6a56190a","455":"ce176963","977":"c5d18a66"}[chunkId] + ".chunk.js";
};